/* eslint-disable */

//tslint:disable

import { IHttpApi, IHttpApiFetchConfig } from '@cian/http-api/shared/http';
import {
  TUpdateVacancyDateModel,
  IUpdateVacancyDateRequest,
  IMappers,
  IUpdateVacancyDateResponse,
  IUpdateVacancyDateResponseError,
  TUpdateVacancyDateResponse,
} from './types';

const defaultConfig: TUpdateVacancyDateModel = {
  apiType: 'public',
  assertStatusCodes: [200, 400],
  method: 'POST',
  microserviceName: 'vacancies',
  pathApi: '/v1/update-vacancy-date/',
  hostType: 'api',
} as TUpdateVacancyDateModel;

function createUpdateVacancyDateModel(parameters: IUpdateVacancyDateRequest): TUpdateVacancyDateModel {
  return {
    ...defaultConfig,
    parameters,
  };
}

export interface IUpdateVacancyDateOptions<TResponse200, TResponse400> {
  httpApi: IHttpApi;
  parameters: IUpdateVacancyDateRequest;
  config?: IHttpApiFetchConfig;
  mappers?: IMappers<TResponse200, TResponse400>;
}

async function fetchUpdateVacancyDate<TResponse200, TResponse400>({
  httpApi,
  parameters,
  config,
  mappers,
}: IUpdateVacancyDateOptions<TResponse200, TResponse400>): Promise<
  TResponse200 | TResponse400 | TUpdateVacancyDateResponse
> {
  const { response, statusCode } = await httpApi.fetch(createUpdateVacancyDateModel(parameters), config);

  if (mappers && statusCode in mappers) {
    if (statusCode === 200) {
      return mappers[200](response as IUpdateVacancyDateResponse);
    }

    if (statusCode === 400) {
      return mappers[400](response as IUpdateVacancyDateResponseError);
    }
  }

  return { response, statusCode } as TUpdateVacancyDateResponse;
}

export { defaultConfig, createUpdateVacancyDateModel, fetchUpdateVacancyDate };
